import { PreAhaPath, TypeOfGL } from '../../PreAhaMoment.types';
import { messages } from './FirstScreen.messages';

export const titleByPath: Record<PreAhaPath, string> = {
    [PreAhaPath.Path1]: messages.titlePath1,
    [PreAhaPath.Path2]: messages.titlePath2,
    [PreAhaPath.Path3]: messages.titlePath3,
};

export const nameByTypeOfGL: Record<TypeOfGL, string> = {
    [TypeOfGL.Xero]: messages.xero,
    [TypeOfGL.QuickBooks]: messages.quickBooksOnline,
    [TypeOfGL.NetSuite]: messages.oracleNetSuite,
    [TypeOfGL.Cin7]: messages.cin7Core,
    [TypeOfGL.Other]: messages.otherGL,
};
